module.exports = __webpack_public_path__ + "assets/img/car3.6feb5774.png";